// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + ({"88":"browse","596":"404","922":"edit"}[chunkId] || chunkId) + "." + {"88":"4304fcb4","431":"21a51bc3","596":"00233a86","670":"62c87b80","922":"7607b574","978":"d965e26b"}[chunkId] + ".css";
};